import axios from "@/config/axios";
export default {
    //预约咨询
    Shanghai_wx_make_add : data => axios.post("/index.php/Home/index/Shanghai_wx_make_add", data),
};
